// Mock data for IrisTechLabs Website

export const companyMetrics = {
  yearsExpertise: "10+",
  globalClients: "10+",
  complianceFrameworks: "20+",
  falsePositiveReduction: "70%",
  mtddReduction: "75%",
  threatAccuracy: "99.9%",
  slaUptime: "99.9%"
};

// NEW FEATURED SERVICE - AI Red Teaming & LLM Security
export const featuredService = {
  id: 0,
  name: "AI Red Teaming & LLM Security Consultancy",
  shortName: "AI-RED-TEAM",
  tagline: "Stress-test your AI systems before attackers do",
  description: "Protect your organization's AI investments with expert adversarial testing and security assessments for Large Language Models (LLMs), Generative AI systems, and AI-powered applications. Our specialized team identifies vulnerabilities in your AI infrastructure before malicious actors can exploit them.",
  icon: "Brain",
  image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlfGVufDB8fHx8MTcwOTI5MTIwMHww&ixlib=rb-4.1.0&q=85",
  features: [
    "LLM Vulnerability Assessment - Prompt injection & jailbreak testing",
    "Data Leakage & PII Exposure Analysis for AI systems",
    "Model Manipulation & Adversarial Attack Simulation",
    "RAG (Retrieval-Augmented Generation) Security Audits",
    "Chatbot & Virtual Assistant Security Testing",
    "AI Model Poisoning & Backdoor Detection",
    "Guardrails & Content Filtering Validation"
  ],
  benefits: [
    "Identify AI vulnerabilities before production deployment",
    "OWASP Top 10 for LLMs alignment & compliance",
    "Protect against prompt injection attacks",
    "Secure your RAG pipelines and vector databases",
    "Third-party AI vendor risk evaluation",
    "AI governance framework implementation"
  ],
  useCases: [
    "Pre-deployment LLM security assessment",
    "ChatGPT/GPT-4 integration security audit",
    "Enterprise AI chatbot penetration testing",
    "Generative AI application security review",
    "AI-powered customer service security validation",
    "LLM-based code assistant security testing"
  ],
  problemStatement: "Organizations rapidly deploying LLMs and Generative AI face unprecedented security risks including prompt injection, data leakage, model manipulation, and jailbreaking - traditional security testing cannot address these AI-specific vulnerabilities.",
  architecture: "Comprehensive AI red teaming methodology combining automated vulnerability scanning, manual adversarial testing, and continuous monitoring for LLM-specific attack vectors aligned with OWASP LLM Top 10.",
  seoKeywords: ["AI red teaming", "LLM security", "prompt injection testing", "AI penetration testing", "generative AI security", "ChatGPT security audit", "AI vulnerability assessment", "OWASP LLM Top 10", "LLM security consultancy", "AI security assessment"]
};

export const flagshipProducts = [
  {
    id: 1,
    name: "Iris AI-Enhanced XDR",
    shortName: "XDR",
    tagline: "Extended Detection & Response",
    description: "Unified endpoint, network, and cloud telemetry with AI-driven threat correlation and real-time automated response.",
    icon: "Shield",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxkYXRhJTIwYW5hbHl0aWNzfGVufDB8fHx8MTc3MjEzNjgwNHww&ixlib=rb-4.1.0&q=85",
    features: [
      "Unified endpoint, network, and cloud telemetry integration",
      "AI-driven threat correlation with real-time automated response",
      "Sub-second threat detection with 99.9% accuracy",
      "Integrated threat hunting capabilities",
      "ML-based anomaly detection"
    ],
    benefits: [
      "75% reduction in Mean Time to Detect (MTTD)",
      "Automated incident response",
      "Unified security visibility",
      "Advanced threat hunting"
    ],
    useCases: [
      "Enterprise threat detection",
      "Multi-cloud security monitoring",
      "Advanced persistent threat (APT) detection",
      "Zero-day threat identification"
    ],
    problemStatement: "Traditional SIEM solutions generate excessive false positives and lack real-time correlation across multiple security domains, leading to delayed threat detection.",
    architecture: "Cloud-native platform integrating endpoint, network, and cloud telemetry with ML-powered correlation engine and automated response orchestration."
  },
  {
    id: 2,
    name: "Iris AI BAS",
    shortName: "BAS",
    tagline: "Breach & Attack Simulation",
    description: "AI-powered continuous red teaming with 24/7 automated security validation and real-world APT pattern simulation.",
    icon: "Target",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxkYXRhJTIwYW5hbHl0aWNzfGVufDB8fHx8MTc3MjEzNjgwNHww&ixlib=rb-4.1.0&q=85",
    features: [
      "AI-Powered Continuous Red Teaming (24/7 automated validation)",
      "Real-World APT Patterns simulation",
      "Security Control Effectiveness Scoring",
      "ML-Based Attack Behaviour Emulation",
      "Compliance-ready validation reports"
    ],
    benefits: [
      "Continuous security validation",
      "Quantifiable security metrics",
      "Proactive vulnerability identification",
      "Compliance demonstration"
    ],
    useCases: [
      "Security control validation",
      "Compliance testing automation",
      "Red team exercise simulation",
      "Defense capability assessment"
    ],
    problemStatement: "Annual penetration testing provides only point-in-time security validation, leaving organizations vulnerable between assessments.",
    architecture: "Automated simulation platform with ML-based attack behavior engine, continuously testing security controls across infrastructure."
  },
  {
    id: 3,
    name: "Iris ML-Driven CTEM",
    shortName: "CTEM",
    tagline: "Continuous Threat Exposure Management",
    description: "Gartner-aligned CTEM platform with ML-powered continuous monitoring, AI-prioritized vulnerability assessment, and integrated Third-Party Risk Management (TPRM) capabilities.",
    icon: "Activity",
    image: "https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHxzZWFyY2h8MXx8ZGF0YSUyMGFuYWx5dGljc3xlbnwwfHx8fDE3NzIxMzY4MDR8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "Continuous threat landscape monitoring with ML algorithms",
      "AI-prioritized vulnerability assessment with real-time risk scoring",
      "Predictive intelligence for attack path forecasting",
      "Business impact-based risk quantification",
      "Security posture optimization recommendations",
      "AI-Powered Third-Party Risk Assessment (TPRM) integration",
      "Vendor risk scoring with continuous monitoring"
    ],
    benefits: [
      "Proactive threat identification",
      "Business-aligned risk prioritization",
      "Reduced exposure window",
      "Optimized security investments",
      "Complete vendor ecosystem visibility"
    ],
    useCases: [
      "Enterprise exposure management",
      "Attack surface reduction",
      "Risk-based vulnerability management",
      "Security posture optimization",
      "Third-party vendor risk assessment"
    ],
    problemStatement: "Organizations struggle to prioritize vulnerabilities effectively, lacking business context and continuous visibility into their threat exposure, including risks from third-party vendors and supply chain partners.",
    architecture: "Gartner CTEM-aligned platform with ML threat intelligence, attack path modeling, business risk correlation engine, and integrated TPRM module for vendor ecosystem monitoring."
  },
  {
    id: 4,
    name: "Iris AI-Led EASM + TPRM",
    shortName: "EASM",
    tagline: "External Attack Surface & Third-Party Risk Management",
    description: "Real-time asset discovery with ML-powered risk classification, dark web intelligence, and comprehensive AI-driven Third-Party Risk Management (TPRM) for complete vendor ecosystem security.",
    icon: "Globe",
    image: "https://images.pexels.com/photos/5380618/pexels-photo-5380618.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: [
      "Real-Time Asset Discovery (AI scanning for exposed assets and shadow IT)",
      "Brand Monitoring & Risk Protection",
      "ML-Powered Risk Classification",
      "Dark Web Intelligence aggregation",
      "Continuous external perimeter monitoring",
      "AI-Powered Third-Party Risk Assessment (TPRM)",
      "Automated vendor onboarding and risk scoring",
      "Real-time vendor security posture monitoring",
      "Supply chain vulnerability detection",
      "Predictive analytics for third-party risks"
    ],
    benefits: [
      "Complete external visibility",
      "Shadow IT discovery",
      "Brand protection",
      "Threat intelligence integration",
      "80% faster vendor risk assessments",
      "Continuous third-party monitoring",
      "Reduced supply chain attack exposure"
    ],
    useCases: [
      "External attack surface mapping",
      "Shadow IT discovery",
      "Brand impersonation detection",
      "Third-party vendor risk assessment",
      "Supply chain security monitoring",
      "Vendor compliance validation",
      "M&A due diligence security assessments"
    ],
    problemStatement: "Organizations lack visibility into their external attack surface and third-party vendor ecosystem, leaving them vulnerable to supply chain attacks, vendor breaches, and expanding threat exposure from partner networks.",
    architecture: "Automated discovery engine with ML classification, integrated dark web monitoring, continuous external scanning, and AI-powered TPRM module featuring automated vendor assessment, real-time risk scoring, and supply chain threat intelligence."
  },
  {
    id: 5,
    name: "Iris Autonomous SOC",
    shortName: "SOC",
    tagline: "AI-Powered Security Operations",
    description: "24/7 AI-augmented threat hunting with automated incident response and SOAR integration.",
    icon: "Eye",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxkYXRhJTIwYW5hbHl0aWNzfGVufDB8fHx8MTc3MjEzNjgwNHww&ixlib=rb-4.1.0&q=85",
    features: [
      "24/7 AI-augmented threat hunting",
      "Automated incident triage and response",
      "SOAR integration for workflow automation",
      "Advanced UEBA (User and Entity Behavior Analytics)",
      "Integrated threat intelligence"
    ],
    benefits: [
      "Reduced analyst workload",
      "Faster incident response",
      "Continuous threat monitoring",
      "Scalable security operations"
    ],
    useCases: [
      "Managed security operations",
      "Threat hunting automation",
      "Incident response orchestration",
      "Security analytics"
    ],
    problemStatement: "Traditional SOCs struggle with alert fatigue, analyst shortage, and slow response times, leaving organizations vulnerable to sophisticated attacks.",
    architecture: "AI-powered SOC platform with automated triage, SOAR integration, and ML-based threat correlation."
  },
  {
    id: 6,
    name: "Iris AI-Enhanced EDR",
    shortName: "EDR",
    tagline: "Intelligent Endpoint Protection & Response",
    description: "AI-powered endpoint security with behavioral analytics, automated threat hunting, and real-time response. Protects against fileless malware, APTs, ransomware, and zero-day attacks with ML-driven anomaly detection and automated remediation.",
    icon: "Lock",
    image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxjeWJlcnNlY3VyaXR5JTIwZW5kcG9pbnR8ZW58MHx8fHwxNzA5MjkxMjAwfDA&ixlib=rb-4.1.0&q=85",
    features: [
      "AI-Powered Behavioral Baselining - Learn normal endpoint/user behavior",
      "Fileless Malware & Living-off-the-Land Attack Detection",
      "Automated Threat Hunting with MITRE ATT&CK Mapping",
      "Real-time Endpoint Isolation & Ransomware Rollback",
      "ML-Based Anomaly Detection for Zero-Day Threats",
      "Command-Line Analysis with AI Explainability",
      "Forensic Timeline & Attack Path Reconstruction"
    ],
    benefits: [
      "90% reduction in endpoint compromise dwell time",
      "Automated response to ransomware within seconds",
      "Zero-day threat detection without signatures",
      "Reduced analyst workload with AI-assisted triage",
      "Complete endpoint visibility across hybrid environments"
    ],
    useCases: [
      "Ransomware prevention and rollback",
      "Insider threat detection on endpoints",
      "Fileless malware and script-based attack protection",
      "Remote workforce endpoint security",
      "Compliance monitoring for endpoint controls"
    ],
    problemStatement: "Traditional antivirus solutions miss sophisticated attacks like fileless malware, living-off-the-land techniques, and zero-day exploits. Security teams face alert fatigue from high false positive rates and lack visibility into endpoint behavior patterns.",
    architecture: "Lightweight AI-powered agent with cloud-based ML analytics engine, providing real-time behavioral analysis, automated threat correlation, and instant response orchestration across all endpoints."
  },
  {
    id: 7,
    name: "Iris AI-Driven DLP",
    shortName: "DLP",
    tagline: "Context-Aware Data Protection",
    description: "Next-generation AI-powered Data Loss Prevention with intelligent classification, context-aware policy enforcement, and GenAI governance. Protects sensitive data across endpoints, cloud, SaaS, and AI applications with minimal false positives.",
    icon: "Database",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxkYXRhJTIwcHJvdGVjdGlvbnxlbnwwfHx8fDE3MDkyOTEyMDB8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "AI-Driven Data Classification - ML-powered sensitive data discovery",
      "Context-Aware Policy Enforcement - User behavior + data sensitivity",
      "GenAI Governance - Monitor data shared with ChatGPT, Copilot, etc.",
      "Data Lineage & Flow Tracking across apps and transformations",
      "Real-Time Coaching & Adaptive Response for users",
      "Cloud & SaaS DLP - Inline + API inspection for all apps",
      "Endpoint Controls - USB, clipboard, print, screen capture prevention"
    ],
    benefits: [
      "80% reduction in false positives vs traditional DLP",
      "Complete visibility into GenAI data exposure",
      "Protect sensitive data without disrupting workflows",
      "Unified policy across endpoint, cloud, and SaaS",
      "Automated compliance reporting (DPDP, GDPR, PCI-DSS)"
    ],
    useCases: [
      "Prevent data exfiltration to unauthorized cloud apps",
      "GenAI/ChatGPT data governance and monitoring",
      "Insider threat prevention and detection",
      "PII and sensitive data protection for compliance",
      "Secure collaboration in hybrid work environments"
    ],
    problemStatement: "Organizations struggle with data sprawl across cloud, SaaS, and GenAI tools. Traditional DLP creates excessive false positives, disrupts productivity, and lacks context to distinguish legitimate use from risky behavior.",
    architecture: "Cloud-native DLP platform with ML classification engine, inline and API-based inspection, unified policy management, and integration with SIEM/SOAR/XDR for centralized incident response."
  }
];

export const industries = [
  {
    id: 1,
    name: "BFSI",
    fullName: "Banking, Financial Services & Insurance",
    description: "Specialized cybersecurity solutions for banks, financial institutions, and insurance companies facing sophisticated financial cyber threats.",
    icon: "Building2",
    image: "https://images.pexels.com/photos/163056/computer-buy-money-banknotes-163056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    threatLandscape: [
      "Advanced financial fraud and account takeover",
      "Ransomware targeting financial operations",
      "API security vulnerabilities in digital banking",
      "Insider threats and privilege abuse"
    ],
    regulations: ["RBI Cybersecurity Guidelines", "DPDP India", "PCI-DSS", "ISO 27001"],
    solutions: [
      "Zero Trust Identity Management",
      "AI-Enhanced XDR for financial fraud detection",
      "Continuous exposure management aligned with RBI",
      "Risk quantification for cyber insurance"
    ]
  },
  {
    id: 2,
    name: "Healthcare",
    fullName: "Healthcare & Life Sciences",
    description: "Protecting patient data and critical healthcare infrastructure with HIPAA-compliant security solutions.",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxoZWFsdGhjYXJlJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc3MjEzNjgyOHww&ixlib=rb-4.1.0&q=85",
    threatLandscape: [
      "Patient data breaches and PHI theft",
      "Medical device vulnerabilities",
      "Ransomware targeting healthcare operations",
      "Supply chain attacks on medical suppliers"
    ],
    regulations: ["HIPAA", "DPDP India", "GDPR (for EU patients)", "FDA Medical Device Security"],
    solutions: [
      "Healthcare-specific XDR with PHI protection",
      "Medical device security assessment",
      "HIPAA compliance automation",
      "Ransomware protection for healthcare"
    ]
  },
  {
    id: 3,
    name: "Government",
    fullName: "Government & Public Sector",
    description: "Nation-state threat protection and critical infrastructure security for government agencies.",
    icon: "Building",
    image: "https://images.unsplash.com/photo-1643391448659-8e58f99958b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxiYW5raW5nJTIwZmluYW5jZXxlbnwwfHx8fDE3NzIxMzY4MjR8MA&ixlib=rb-4.1.0&q=85",
    threatLandscape: [
      "Nation-state APT campaigns",
      "Critical infrastructure targeting",
      "Data exfiltration and espionage",
      "Supply chain compromise"
    ],
    regulations: ["National Cyber Security Policy", "CERT-In Guidelines", "DPDP India", "Zero Trust Architecture"],
    solutions: [
      "APT detection and response",
      "Zero Trust implementation for government",
      "Secure Service Edge (SSE) deployment",
      "Critical infrastructure protection"
    ]
  },
  {
    id: 4,
    name: "Critical Infrastructure",
    fullName: "Energy, Utilities & Critical Infrastructure",
    description: "Securing power grids, water systems, and telecommunications against cyber-physical attacks.",
    icon: "Zap",
    image: "https://images.pexels.com/photos/17489160/pexels-photo-17489160.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    threatLandscape: [
      "Industrial control system (ICS) attacks",
      "SCADA system vulnerabilities",
      "Cyber-physical attacks on infrastructure",
      "Nation-state critical infrastructure targeting"
    ],
    regulations: ["IEC 62443", "NIST Cybersecurity Framework", "NERC CIP", "National Critical Infrastructure Protection"],
    solutions: [
      "OT/IT security convergence",
      "ICS/SCADA security monitoring",
      "Critical infrastructure BAS",
      "Industrial cybersecurity assessments"
    ]
  },
  {
    id: 5,
    name: "Technology",
    fullName: "Technology & SaaS Startups",
    description: "Scalable security solutions for growing technology companies and SaaS platforms.",
    icon: "Code",
    image: "https://images.unsplash.com/photo-1614064643392-8dd713152ae9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxlbnRlcnByaXNlJTIwY3liZXJzZWN1cml0eXxlbnwwfHx8fDE3NzIxMzY3NzF8MA&ixlib=rb-4.1.0&q=85",
    threatLandscape: [
      "API security vulnerabilities",
      "Software supply chain attacks",
      "Cloud misconfiguration",
      "Intellectual property theft"
    ],
    regulations: ["SOC 2", "ISO 27001", "GDPR", "CCPA", "DPDP India"],
    solutions: [
      "Cloud security posture management (CSPM)",
      "DevSecOps integration",
      "API security testing",
      "SaaS security assessment"
    ]
  }
];

export const complianceFrameworks = [
  {
    id: 1,
    name: "CTEM Framework",
    fullName: "Continuous Threat Exposure Management",
    description: "Gartner-aligned CTEM framework for continuous security validation and exposure management.",
    icon: "Target",
    category: "Framework",
    alignment: "Iris CTEM platform fully implements Gartner's 5-stage CTEM framework: Scoping, Discovery, Prioritization, Validation, and Mobilization."
  },
  {
    id: 2,
    name: "AI TRiSM",
    fullName: "AI Trust, Risk & Security Management",
    description: "Gartner framework for managing AI model risks, security, and trustworthiness.",
    icon: "Brain",
    category: "AI Governance",
    alignment: "Iris AI TRiSM Suite provides model monitoring, bias detection, prompt injection protection, and AI governance reporting."
  },
  {
    id: 3,
    name: "DPDP India",
    fullName: "Digital Personal Data Protection Act (India)",
    description: "India's comprehensive data protection regulation for personal data processing.",
    icon: "Shield",
    category: "Regulation",
    alignment: "Complete DPDP compliance services including data mapping, consent management, and breach notification automation."
  },
  {
    id: 4,
    name: "GDPR",
    fullName: "General Data Protection Regulation",
    description: "EU regulation for data protection and privacy in the European Union.",
    icon: "Lock",
    category: "Regulation",
    alignment: "Full GDPR compliance support including data discovery, privacy impact assessments, and right-to-be-forgotten automation."
  },
  {
    id: 5,
    name: "DORA",
    fullName: "Digital Operational Resilience Act",
    description: "EU regulation for financial sector digital operational resilience.",
    icon: "Shield",
    category: "Financial Regulation",
    alignment: "DORA compliance services for financial institutions including ICT risk management and incident reporting."
  },
  {
    id: 6,
    name: "Zero Trust",
    fullName: "Zero Trust Architecture",
    description: "Security model requiring strict identity verification for every access request.",
    icon: "UserCheck",
    category: "Architecture",
    alignment: "Complete Zero Trust implementation including ZTNA, identity management, and micro-segmentation."
  },
  {
    id: 7,
    name: "HIPAA",
    fullName: "Health Insurance Portability and Accountability Act",
    description: "US regulation for healthcare data protection and privacy.",
    icon: "Heart",
    category: "Healthcare Regulation",
    alignment: "HIPAA compliance services for healthcare including PHI protection, access controls, and audit logging."
  },
  {
    id: 8,
    name: "SOC 2",
    fullName: "Service Organization Control 2",
    description: "Framework for managing customer data based on security, availability, and confidentiality.",
    icon: "FileCheck",
    category: "Compliance",
    alignment: "SOC 2 Type II audit preparation and continuous compliance monitoring for SaaS companies."
  }
];

export const investorData = {
  marketOpportunity: {
    globalCybersecurityMarket: "$345B by 2026",
    aiSecurityMarket: "$85B by 2027",
    indiaMarketGrowth: "15% CAGR",
    cagr: "12.5%"
  },
  competitiveAdvantages: [
    "AI-first architecture across all products",
    "Gartner-aligned technology (CTEM, AI TRiSM)",
    "India-focused regulatory expertise (DPDP, RBI)",
    "10+ years enterprise cybersecurity experience",
    "Scalable SaaS platform model"
  ],
  expansionRoadmap: [
    {
      phase: "Phase 1 (2025)",
      focus: "India BFSI market penetration",
      target: "Tier-1 banks and insurance companies"
    },
    {
      phase: "Phase 2 (2026)",
      focus: "Healthcare and government expansion",
      target: "Multi-industry presence in India"
    },
    {
      phase: "Phase 3 (2027-2028)",
      focus: "International expansion (APAC, Middle East)",
      target: "Regional market leadership"
    }
  ],
  productFlywheel: [
    "AI models improve with customer data",
    "Better detection reduces false positives",
    "Reduced false positives increase adoption",
    "More customers = better AI models"
  ]
};

export const resources = [
  {
    id: 1,
    title: "What is CTEM India?",
    type: "Article",
    description: "Comprehensive guide to Continuous Threat Exposure Management and its importance for Indian enterprises.",
    readTime: "8 min",
    category: "CTEM",
    url: "#"
  },
  {
    id: 2,
    title: "AI TRiSM Explained",
    type: "Whitepaper",
    description: "Understanding AI Trust, Risk & Security Management framework for enterprise AI adoption.",
    readTime: "15 min",
    category: "AI Security",
    url: "#"
  },
  {
    id: 3,
    title: "BAS vs Traditional Pentesting",
    type: "Article",
    description: "Why continuous breach simulation outperforms annual penetration testing.",
    readTime: "10 min",
    category: "BAS",
    url: "#"
  },
  {
    id: 4,
    title: "Risk Quantification in Cybersecurity",
    type: "Guide",
    description: "Financial modeling approach to cyber risk for insurance and compliance.",
    readTime: "12 min",
    category: "Risk Management",
    url: "#"
  },
  {
    id: 5,
    title: "Zero Trust for BFSI",
    type: "Case Study",
    description: "Implementing Zero Trust Architecture in Indian banking sector.",
    readTime: "10 min",
    category: "Zero Trust",
    url: "#"
  },
  {
    id: 6,
    title: "Continuous Red Teaming Strategy",
    type: "Whitepaper",
    description: "Building continuous security validation programs for enterprises.",
    readTime: "18 min",
    category: "Red Team",
    url: "#"
  },
  {
    id: 7,
    title: "AI-Powered Third-Party Risk Management",
    type: "Whitepaper",
    description: "How AI transforms vendor risk assessment from periodic reviews to continuous, real-time monitoring.",
    readTime: "20 min",
    category: "TPRM",
    url: "#"
  },
  {
    id: 8,
    title: "Supply Chain Security in 2025",
    type: "Guide",
    description: "Protecting your organization from third-party and supply chain cyber attacks.",
    readTime: "14 min",
    category: "Supply Chain",
    url: "#"
  },
  {
    id: 9,
    title: "Vendor Risk Scoring with ML",
    type: "Article",
    description: "Using machine learning for automated, continuous vendor security posture assessment.",
    readTime: "10 min",
    category: "TPRM",
    url: "#"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "IrisTechLabs' AI-powered XDR reduced our false positives by 70% and detection time by 75%. Game-changer for our security operations.",
    author: "CISO, Leading Indian Bank",
    company: "Major BFSI Institution",
    role: "Chief Information Security Officer"
  },
  {
    id: 2,
    quote: "Their CTEM platform helped us achieve complete visibility into our threat exposure and prioritize remediation based on business risk.",
    author: "VP Security, Healthcare Provider",
    company: "Multi-Specialty Hospital Chain",
    role: "Vice President, Security"
  },
  {
    id: 3,
    quote: "The continuous BAS platform transformed our security validation from annual pentests to 24/7 automated red teaming.",
    author: "Security Director, Tech Startup",
    company: "SaaS Unicorn",
    role: "Director of Security Engineering"
  }
];

export const ctaContent = {
  primary: {
    title: "Ready to Transform Your Security Posture?",
    description: "Schedule a complimentary CTEM assessment and discover how AI-powered cybersecurity can protect your enterprise.",
    buttonText: "Schedule Assessment",
    buttonUrl: "#contact"
  },
  secondary: {
    title: "Download Our BFSI Security Whitepaper",
    description: "AI-Driven Continuous Exposure Management for Indian Banking & Financial Services",
    buttonText: "Download Whitepaper",
    buttonUrl: "#download"
  }
};
